import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import store, { persistor } from './state'
import AuthInitGuard from './views/components/auth-guard-check/index.component'

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthInitGuard />
      </PersistGate>
    </Provider>
  )
}
export default App
